import { useQuery } from '@tanstack/react-query'
import { useApiWrapperWithErrorValidation } from 'shared/hooks/use-api-wrapper-with-error-validation'
import { RequestMethodsEnum } from 'shared/hooks/use-api-wrapper-with-error-validation/types'
import { UseQueryClearOptions } from 'shared/types/tanstack-utility-types'
import { communityKeys } from './key-factory'

export interface UseCommunitySearchSuggestionsOptions
  extends Omit<UseQueryClearOptions<string[], Error, string[]>, 'placeholderData'> {
  path: string
  topicPath?: string
  query?: string
}

export const useCommunitySearchSuggestions = ({
  path,
  topicPath,
  query,
  ...options
}: UseCommunitySearchSuggestionsOptions) => {
  const { fetcher } = useApiWrapperWithErrorValidation<RequestMethodsEnum.get, string[]>({
    method: RequestMethodsEnum.get,
  })

  return useQuery({
    queryKey: communityKeys.searchSuggestions(path, topicPath, query),
    queryFn: async () => {
      if (!query) {
        return []
      }
      return await fetcher(
        `/api/community/community/${path}/autocomplete?searchBy=${encodeURIComponent(query)}&topicPath=${encodeURIComponent(topicPath || '')}`,
      )
    },
    placeholderData: (prevData: string[] | undefined) => prevData || [],
    ...options,
  })
}
